export enum TimelineShowItemFor {
  OnlyEntry = 1,
  CurrentEntryAndAbEntry = 2,
}
